import { render, staticRenderFns } from "./WizardLiveStep.vue?vue&type=template&id=f3683c70&scoped=true"
import script from "./WizardLiveStep.vue?vue&type=script&lang=js"
export * from "./WizardLiveStep.vue?vue&type=script&lang=js"
import style0 from "./WizardLiveStep.vue?vue&type=style&index=0&id=f3683c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3683c70",
  null
  
)

export default component.exports